import { ComponentStyleConfig } from "@chakra-ui/react";

const Badge: ComponentStyleConfig = {
  baseStyle: { rounded: "2xl", px: "3", py: "0.5" },
  defaultProps: { colorScheme: "green" },
};

export default Badge;
